// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2U2Gi","modalQuestionWrapper":"styles_modalQuestionWrapper__372vC"};